import React from 'react'

import { Cultured, DeepSpaceGrey, FielderHard, LightGreySubtitleColor, RosePompadour } from '@core/theme/baseTheme';
import { alpha, styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid2';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { motion } from 'framer-motion';

const ACTIVE = '#dc5c87';
export const FielderTabPanel = motion(Grid);
export const FielderTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
	textTransform: 'none',
	fontWeight: theme.typography.fontWeightRegular,
	fontSize: theme.typography.pxToRem(15),
  color: theme.palette.text.secondary,
  '&:hover': {
    borderBottom: `1px solid ${FielderHard}`,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    color: ACTIVE,
    backgroundColor:
      theme.palette.mode === 'dark'
        ? alpha(ACTIVE, 0.12)
        : alpha(ACTIVE, 0.08),
  },
	'&.Mui-selected': {
		color: theme.palette.text.secondary,
    backgroundColor:
      theme.palette.mode === 'dark'
        ? alpha(ACTIVE, 0.18)
        : alpha(ACTIVE, 0.12),
    borderBottom: `1px solid ${FielderHard}`,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
	}
}));

export const FielderTabs = styled((props) => (
	<Tabs variant="fullWidth" slotProps={{
    indicator: { sx: { backgroundColor: '#dc5c87' } },
  }} {...props} />
))({
  minHeight: 46,
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    bottom: 0,
  },
  '& .MuiTabs-indicatorSpan': {
    maxWidth: '100%',
    width: '100%',
    height: 3,
    borderRadius: 0,
    backgroundColor: ACTIVE,
  },
});
